import createVueApp from '@/common/createApp'

Styxie.Initializers.Onboarding = {
  show: async(props) => {
    const { default: OnboardingWizard } = await import('@/vue_widgets/local_optics/onboarding/OnboardingWizard.vue')
    createVueApp(OnboardingWizard, { props })
  }
}
